import React from "react";
import "../../css/pdfOpenLink.css";

const PdfOpenLink = ({ url, label = "結果PDFを開く", className = "", style }) => {
  if (!url) return null;

  const classes = ["pdf-open-link", className].filter(Boolean).join(" ");

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={classes}
      style={style}
    >
      {label}
    </a>
  );
};

export default PdfOpenLink;
